module.exports = __webpack_public_path__ + "media/images/newsletter/newsletter-style-check-cc77566c634f0209af6b2c54999adf42.png";